$('#logos').owlCarousel({
	loop:false,
	margin:30,
	nav:false,
		responsive:{
			0:{
			items:5, loop:false,
			},
		600:{
			items:5,   loop:false,
			},
		1000:{
			items:5
		}
	}
});


  



